import { applyFormatters } from 'mobx-log';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from 'src/app/components';
import './index.css';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV === 'development') {
  applyFormatters();
}

const strict = false;

ReactDOM.render(
  strict ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  ),
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
